import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите количество подписантов", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Выберите из списка", -1)
const _hoisted_5 = {
  key: 0,
  style: {"width":"230px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите подписанта 1", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Выберите подписанта из списка", -1)
const _hoisted_8 = {
  key: 1,
  style: {"width":"230px","margin-left":"250px","margin-top":"-125px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Укажите должность", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Ген. дир., Выполнил", -1)
const _hoisted_11 = {
  key: 2,
  style: {"width":"230px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите подписанта 3", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Выберите подписанта из списка", -1)
const _hoisted_14 = {
  key: 3,
  style: {"width":"230px","margin-left":"250px","margin-top":"-125px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Укажите должность", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Ген. дир., Выполнил", -1)
const _hoisted_17 = {
  key: 4,
  style: {"width":"230px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите подписанта 5", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Выберите подписанта из списка", -1)
const _hoisted_20 = {
  key: 5,
  style: {"width":"230px","margin-left":"250px","margin-top":"-125px"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Укажите должность", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Ген. дир., Выполнил", -1)
const _hoisted_23 = { class: "right" }
const _hoisted_24 = {
  key: 0,
  style: {"width":"230px","margin-top":"125px"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите подписанта 2", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Выберите подписанта из списка", -1)
const _hoisted_27 = {
  key: 1,
  style: {"width":"230px","margin-left":"250px","margin-top":"-125px"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Укажите должность", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Ген. дир., Выполнил", -1)
const _hoisted_30 = {
  key: 2,
  style: {"width":"230px"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите подписанта 4", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Выберите подписанта из списка", -1)
const _hoisted_33 = {
  key: 3,
  style: {"width":"230px","margin-left":"250px","margin-top":"-125px"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Укажите должность", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Ген. дир., Выполнил", -1)
const _hoisted_36 = {
  key: 4,
  style: {"width":"230px"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите подписанта 6", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "Выберите подписанта из списка", -1)
const _hoisted_39 = {
  key: 5,
  style: {"width":"230px","margin-left":"250px","margin-top":"-125px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Укажите должность", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Ген. дир., Выполнил", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.employee_title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employee_title) = $event)),
          editable: "",
          options: _ctx.employee_options,
          optionLabel: "name",
          placeholder: _ctx.employee_default.name,
          style: {"width":"480px"},
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.employee_change($event)))
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      (_ctx.document.employee_count >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.signatory1_name_title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signatory1_name_title) = $event)),
              editable: "",
              options: _ctx.signatory_name_options,
              optionLabel: "name",
              placeholder: _ctx.signatory_name_default.name,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signatory_name_change($event,1)))
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee1_id != 0 && _ctx.document.employee_count >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              style: {"width":"230px"},
              class: "input",
              type: "text",
              placeholder: "Укажите должность",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.employee1_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.employee1_name]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee_count >= 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.signatory3_name_title,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signatory3_name_title) = $event)),
              editable: "",
              options: _ctx.signatory_name_options,
              optionLabel: "name",
              placeholder: _ctx.signatory_name_default.name,
              style: {"width":"230px"},
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.signatory_name_change($event,3)))
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee3_id != 0 && _ctx.document.employee_count >= 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              style: {"width":"230px"},
              class: "input",
              type: "text",
              placeholder: "Укажите должность",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.document.employee3_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.employee3_name]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee_count >= 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.signatory5_name_title,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.signatory5_name_title) = $event)),
              editable: "",
              options: _ctx.signatory_name_options,
              optionLabel: "name",
              placeholder: _ctx.signatory_name_default.name,
              style: {"width":"230px"},
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.signatory_name_change($event,5)))
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee5_id != 0 && _ctx.document.employee_count >= 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              style: {"width":"230px"},
              class: "input",
              type: "text",
              placeholder: "Укажите должность",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.document.employee5_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.employee5_name]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.document.employee_count >= 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _hoisted_26,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.signatory2_name_title,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.signatory2_name_title) = $event)),
              editable: "",
              options: _ctx.signatory_name_options,
              optionLabel: "name",
              placeholder: _ctx.signatory_name_default.name,
              style: {"width":"230px"},
              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.signatory_name_change($event,2)))
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee2_id != 0 && _ctx.document.employee_count >= 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _hoisted_29,
            _withDirectives(_createElementVNode("input", {
              style: {"width":"230px"},
              class: "input",
              type: "text",
              placeholder: "Укажите должность",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.document.employee2_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.employee2_name]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee_count >= 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _hoisted_31,
            _hoisted_32,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.signatory4_name_title,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.signatory4_name_title) = $event)),
              editable: "",
              options: _ctx.signatory_name_options,
              optionLabel: "name",
              placeholder: _ctx.signatory_name_default.name,
              style: {"width":"230px"},
              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.signatory_name_change($event,4)))
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee4_id != 0 && _ctx.document.employee_count >= 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            _withDirectives(_createElementVNode("input", {
              style: {"width":"230px"},
              class: "input",
              type: "text",
              placeholder: "Укажите должность",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.document.employee4_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.employee4_name]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee_count >= 6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _hoisted_37,
            _hoisted_38,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.signatory6_name_title,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.signatory6_name_title) = $event)),
              editable: "",
              options: _ctx.signatory_name_options,
              optionLabel: "name",
              placeholder: _ctx.signatory_name_default.name,
              style: {"width":"230px"},
              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.signatory_name_change($event,6)))
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.employee6_id != 0 && _ctx.document.employee_count >= 6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _hoisted_40,
            _hoisted_41,
            _withDirectives(_createElementVNode("input", {
              style: {"width":"230px"},
              class: "input",
              type: "text",
              placeholder: "Укажите должность",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.document.employee6_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.employee6_name]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}